import { Box, Button, styled } from '@mui/material';

const MainContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0,
  flex: 1,
  minWidth: 0,
}));

const ViewsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  overflowX: 'auto',
  overflowY: 'hidden',
  flex: '1 1 auto',
  minWidth: 0,
  paddingBottom: '12px',
  marginBottom: '-8px',
  scrollbarWidth: 'thin',
  scrollbarGutter: 'stable',
  '&::-webkit-scrollbar': {
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: '#aaa',
    },
  },
}));

const ViewButtonContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  flexShrink: 0,
  marginLeft: '8px',
  '&:first-of-type': {
    marginLeft: 0,
  },
}));

const FILTER_BUTTON_COLOR = '#68B1F1';

const StyledViewButton = styled(Button)<{ isActive?: boolean }>(({ isActive }) => ({
  maxWidth: '220px',
  minWidth: 'auto',
  textTransform: 'none',
  borderRadius: '20px',
  padding: '4px 12px',
  backgroundColor: isActive ? FILTER_BUTTON_COLOR : 'transparent',
  color: isActive ? '#fff' : FILTER_BUTTON_COLOR,
  borderColor: FILTER_BUTTON_COLOR,
  border: `1px solid ${FILTER_BUTTON_COLOR}`,
  '&:hover': {
    backgroundColor: isActive ? '#5a9fd8' : 'rgba(104, 177, 241, 0.08)',
    borderColor: FILTER_BUTTON_COLOR,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
    marginRight: '4px',
  },
  '& .button-text': {
    display: 'block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export { MainContainer, ViewsContainer, ViewButtonContainer, StyledViewButton };

